const _excluded = ["children", "overrideClassName"],
  _excluded2 = ["description", "disabled", "highlighted", "label", "renderEndSlot", "renderStartSlot", "overrideClassName"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import Check from "@bolteu/kalep-react-icons/dist/Check";
import { cx } from "../../helpers/utils/cx";
import { noopNull } from "../../helpers/utils/noop";
export const List = /*#__PURE__*/React.forwardRef(function ListComponent(_ref, ref) {
  let {
      children,
      overrideClassName
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const isHidden = !children;
  return /*#__PURE__*/React.createElement("ul", _extends({
    className: cx("list-none w-96 max-h-80 py-1 px-0 m-0 empty:py-0 bg-layer-floor-2 overflow-y-auto shadow-md", isHidden && "hidden", overrideClassName),
    ref: ref
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- in case it's scrollable.
    ,
    tabIndex: 0
  }, rest), children);
});

/**
 * @deprecated Use `ListItemLayout` instead. `ListItem` will be removed in the next major version.
 * See {@link https://kalep.uip.boltint.net/@bolteu/kalep-react/index.html?path=/story/data-display-listitemlayout--default ListItemLayout documentation in Kalep React Storybook}
 */
export const ListItem = /*#__PURE__*/React.forwardRef(function ListItemComponent(props, ref) {
  const {
      description,
      disabled: isDisabled,
      highlighted: isHighlighted,
      label,
      renderEndSlot = renderItemEndSlotDefault,
      renderStartSlot = noopNull,
      overrideClassName
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/React.createElement("li", _extends({
    className: cx("box-border", "flex items-center gap-3 py-2 px-6", isHighlighted && "bg-neutral-secondary", isDisabled && "cursor-not-allowed", overrideClassName),
    ref: ref
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: cx("flex-shrink-0")
  }, renderStartSlot(props, noopNull)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: cx("bolt-font-body-m-regular", isDisabled ? "text-secondary" : "text-primary")
  }, label), description && /*#__PURE__*/React.createElement("div", {
    className: cx("bolt-font-body-s-regular text-secondary")
  }, description)), /*#__PURE__*/React.createElement("div", {
    className: cx("ml-auto")
  }, renderEndSlot(props, renderItemEndSlotDefault)));
});
function renderItemEndSlotDefault(_ref2) {
  let {
    disabled,
    selected
  } = _ref2;
  if (selected) {
    return /*#__PURE__*/React.createElement("div", {
      className: cx("h-full flex items-center")
    }, /*#__PURE__*/React.createElement(Check, {
      size: "md",
      className: cx(disabled ? "text-secondary" : "text-primary")
    }));
  }
  return null;
}